import * as React from 'react';
import * as styles from './styles.css';
import { StickyContainer, Sticky as StickyLib } from 'react-sticky';

import { checkStickySupported } from './utils';

export interface IStickyProps {
  rootClassName?: string;
  top: number;
  children: React.ReactChild;
}

export function Sticky({ rootClassName, children, top }: IStickyProps) {
  const [stickySupported, setStickySupported] = React.useState(false);
  const [stickyWidth, setStickyWidth] = React.useState('');

  React.useEffect(() => {
    const isStickySupported = checkStickySupported();
    setStickySupported(isStickySupported);

    if (isStickySupported) {
      return;
    }

    const aside = document.querySelector(`.${rootClassName}`);

    if (aside) {
      setStickyWidth(`${aside.getBoundingClientRect().width}px`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (stickySupported) {
    return (
      <div className={rootClassName}>
        <div className={styles['sticky']} style={{ top }}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <StickyContainer className={rootClassName} style={{ width: stickyWidth }}>
      <StickyLib topOffset={-top} bottomOffset={top}>
        {({ style, isSticky }) => (
          <div style={{ ...style }}>
            <div className={styles['sticky-lib']} style={{ top: isSticky ? top : 0 }}>
              {children}
            </div>
          </div>
        )}
      </StickyLib>
    </StickyContainer>
  );
}
